import { NavLink } from "react-router-dom";
import SimilarProjects from "../Elements/SimilarProjects";
var bgimg1 = require("./../../images/background/bg-image.png");

function ProjectDetail({ project }) {
  return (
    <div
      className="section-full p-tb80 inner-page-padding stick_in_parent"
      style={{
        backgroundImage: "url(" + bgimg1 + ")",
        objectPosition: "bottom",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-7  sticky_column">
            <div className="project-detail-containt">
              <div className="bg-cream text-black">
                <SimilarProjects
                  projectImages={project.images}
                  alignment="separator-center"
                  title="Similar Project"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetail;
